import { render, staticRenderFns } from "./NotificationAdd.vue?vue&type=template&id=7f5d436e&"
import script from "./NotificationAdd.vue?vue&type=script&lang=ts&"
export * from "./NotificationAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports